var _excluded = ["node", "disabled", "expandable", "expanded", "selectable", "selected", "multiple", "isActionNode", "highlight", "height", "expandNodeFailureText", "retryButtonText", "treeListRef", "viewItemRenderer", "editItemRenderer", "onReload", "onToggle", "onSelect", "onContextMenu", "matchAlloyStyle", "allowReselectNodes", "showDisabledSelection"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { ChevronDownIcon } from '@adsk/alloy-react-icon';
import Spinner from '@adsk/alloy-react-progress-ring';
import * as TreeHelper from './treeHelper';
import { ItemWrapper, ItemButton, ItemIconWrapper, ItemIcon, ItemLabel, ItemCheckbox, Separator } from './styles';
var TreeNode = function TreeNode(_ref) {
  var node = _ref.node,
    disabled = _ref.disabled,
    expandable = _ref.expandable,
    expanded = _ref.expanded,
    selectable = _ref.selectable,
    selected = _ref.selected,
    multiple = _ref.multiple,
    isActionNode = _ref.isActionNode,
    highlight = _ref.highlight,
    height = _ref.height,
    expandNodeFailureText = _ref.expandNodeFailureText,
    retryButtonText = _ref.retryButtonText,
    treeListRef = _ref.treeListRef,
    viewItemRenderer = _ref.viewItemRenderer,
    editItemRenderer = _ref.editItemRenderer,
    onReload = _ref.onReload,
    onToggle = _ref.onToggle,
    onSelect = _ref.onSelect,
    onContextMenu = _ref.onContextMenu,
    matchAlloyStyle = _ref.matchAlloyStyle,
    allowReselectNodes = _ref.allowReselectNodes,
    showDisabledSelection = _ref.showDisabledSelection,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var isLoadNode = node[TreeHelper.NODE_KEYS.NODE_ACTION_TYPE] === TreeHelper.NODE_KEYS.NODE_LOADER_KEY;
  var isErrorNode = node[TreeHelper.NODE_KEYS.NODE_ACTION_TYPE] === TreeHelper.NODE_KEYS.NODE_ERROR_KEY;
  var isSeparator = node[TreeHelper.NODE_KEYS.NODE_ACTION_TYPE] === TreeHelper.NODE_KEYS.NODE_SEPARATOR_KEY;
  var isSelectable = disabled || isActionNode || !multiple && selected && !allowReselectNodes || node.isEditing ? false : true;
  var handleToggleNode = function handleToggleNode(event) {
    if (event) event.stopPropagation();
    onToggle(node);
  };
  var handleContextMenu = function handleContextMenu(event) {
    if (disabled || node.isEditing) return;
    event.stopPropagation();
    event.preventDefault();
    onContextMenu({
      node: node,
      event: event
    });
  };
  var handleSelectNode = function handleSelectNode(event) {
    // https://reactjs.org/docs/legacy-event-pooling.html
    if (event && event.persist) event.persist();
    if (!selectable && expandable) {
      // Change to toggle node if node can expand but not selectable
      handleToggleNode(event);
      return;
    }
    if (event) event.stopPropagation();
    if (!isSelectable) return;
    onSelect(node, event);
  };
  if (isSeparator) return /*#__PURE__*/React.createElement(ItemWrapper, _extends({
    noHover: true
  }, rest), /*#__PURE__*/React.createElement(Separator, null));
  if (isLoadNode) return /*#__PURE__*/React.createElement(ItemWrapper, rest, /*#__PURE__*/React.createElement(Spinner, {
    size: "small"
  }));
  if (isErrorNode) return /*#__PURE__*/React.createElement(ItemWrapper, rest, expandNodeFailureText, /*#__PURE__*/React.createElement(ItemButton, {
    "data-testid": "retry-button",
    onClick: function onClick() {
      return onReload(node.parentNode);
    }
  }, retryButtonText));
  return /*#__PURE__*/React.createElement(ItemWrapper, _extends({
    highlight: highlight,
    selected: selected,
    selectable: isSelectable,
    disabled: disabled,
    onClick: handleSelectNode,
    onContextMenu: handleContextMenu,
    matchAlloyStyle: matchAlloyStyle,
    multiple: multiple
  }, rest), /*#__PURE__*/React.createElement(ItemIconWrapper, {
    "data-testid": "node-icon",
    height: height,
    disabled: !expandable,
    onClick: handleToggleNode
  }, /*#__PURE__*/React.createElement(ItemIcon, {
    "data-testid": expanded ? 'node-icon-expand' : 'node-icon-collapse',
    as: expandable ? ChevronDownIcon : 'div',
    name: "chevron-down",
    style: {
      transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)'
    }
  })), node.isEditing ? editItemRenderer({
    node: node,
    treeListRef: treeListRef
  }) : /*#__PURE__*/React.createElement(ItemLabel, {
    height: height
  }, multiple && (selectable || showDisabledSelection) && /*#__PURE__*/React.createElement(ItemCheckbox, {
    "data-testid": "node-checkbox",
    checked: selected,
    disabled: disabled
  }), viewItemRenderer({
    node: node,
    treeListRef: treeListRef
  })));
};
TreeNode.propTypes = {
  treeListRef: PropTypes.object,
  node: PropTypes.object.isRequired,
  expandable: PropTypes.bool,
  expanded: PropTypes.bool,
  selectable: PropTypes.bool,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  isActionNode: PropTypes.bool,
  highlight: PropTypes.bool,
  matchAlloyStyle: PropTypes.bool,
  allowReselectNodes: PropTypes.bool,
  showDisabledSelection: PropTypes.bool,
  height: PropTypes.number,
  indent: PropTypes.string,
  retryButtonText: PropTypes.node,
  expandNodeFailureText: PropTypes.node,
  viewItemRenderer: PropTypes.func.isRequired,
  editItemRenderer: PropTypes.func,
  onToggle: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onReload: PropTypes.func.isRequired,
  onContextMenu: PropTypes.func
};
export default TreeNode;
//# sourceMappingURL=TreeNode.js.map